<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card no-header>
          <b-form>
            <b-form-group
              label="Apellido"
              label-for="apellido"
              :label-cols="labelCols">
              <b-form-input 
                id="apellido"
                v-model.trim="$v.apellido.$model"
                :state="apellidoValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="apellidoFeedback">
                {{ apellidoInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Nombre"
              label-for="nombre"
              :label-cols="labelCols">
              <b-form-input 
                id="nombre"
                v-model.trim="$v.nombre.$model"
                :state="nombreValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="nombreFeedback">
                {{ nombreInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <app-documento-tipo
              label="Tipo de Documento"
              :labelCols="labelCols"
              :nombre="documentoTipoNombre"
              :valido="documentoTipoValido"
              :lista="documentosTiposList"
              :msjInvalido="documentoTipoInvalidoMsj"
              @validate="validate"
              @updated="documentoTipoActualizado">
            </app-documento-tipo>  

            <b-form-group
              label="Nro. de Documento"
              label-for="documentoNumero"
              :label-cols="labelCols">
              <b-form-input 
                id="documentoNumero"
                v-model.trim="$v.documentoNumero.$model"
                :state="documentoNumeroValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="documentoNumeroFeedback">
                {{ documentoNumeroInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Fecha de Nacimiento"
              label-for="fechaNacimiento"
              :label-cols="labelCols">
              <b-input-group>
                <b-input-group-prepend is-text>
                  <b-form-checkbox 
                      id="fechaNacimientoHijoHabilitada"
                      v-model="fechaNacimientoHijoHabilitada"
                      value= true
                      unchecked-value= false>
                  </b-form-checkbox>
                </b-input-group-prepend>
                <b-form-input 
                  id="fechaNacimiento" 
                  v-model="$v.fechaNacimiento.$model" 
                  type="date"
                  :disabled="fechaNacimientoHijoDisabled"
                  :state="fechaNacimientoValida"
                  @blur.native="validate">
                </b-form-input>
              </b-input-group>
              <b-form-invalid-feedback id="fechaNacimientoFeedback">
                {{ fechaNacimientoInvalidaMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>
          </b-form>

          <div slot="footer">
            <b-button size="sm" variant="primary" class="footer-button"
              @click.prevent="save">Grabar</b-button>
            <b-button size="sm" variant="danger" class="footer-button"
              @click.prevent="close">Cancelar</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import DocumentoTipo from '../shared/abmSelect.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs';
import moment from 'moment';
import { required, requiredIf, maxLength, numeric } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'personalHijo/getField',
  mutationType: 'personalHijo/updateField',
});

export default {
  name: 'PersonalHijo',
  components: {
    appDocumentoTipo: DocumentoTipo,
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  props: {
    hijo: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      /* Validacion de datos */
      noValidar: true,
      apellidoValido: null,
      apellidoInvalidoMsj: '',
      nombreValido: null,
      nombreInvalidoMsj: '',
      documentoTipoValido: null,
      documentoTipoInvalidoMsj: '',
      documentoNumeroValido: null,
      documentoNumeroInvalidoMsj: '',
      fechaNacimientoValida: null,
      fechaNacimientoInvalidaMsj: '',

      documentosTipos: [],
      documentosTiposList: [],
      
      fechaNacimientoHijoDisabled: true,

      labelCols: 3,
    }
  },
  computed: {
    ...mapFields([
      'id',
      'apellido',
      'nombre',
      'documentoTipo',
      'documentoTipoNombre',
      'documentoNumero',
      'fechaNacimiento',
      'fechaNacimientoHijoHabilitada',
    ])
  },
  created() {
    this.getDatosAdicionales();

    this.showSpinner();
    this.$store.dispatch('personalHijo/inicializar', this.hijo)
      .then (() => {
        if (moment(this.fechaNacimiento).format('YYYY-MM-DD') == '1900-01-01') {
          this.fechaNacimientoHijoDisabled = true;
        } else {
          this.fechaNacimientoHijoDisabled = false;
        }
      })
      .catch( error => this.showErrorMsj (error))
      .finally(() => this.hideSpinner());
  },  
  methods: {
    getDatosAdicionales() {
      const vm = this;

      this.$store.dispatch('documentostipos/getList')
        .then(() => {
          vm.documentosTipos = this.$store.getters['documentostipos/list'];
          vm.documentosTiposList = this.$store.getters['documentostipos/selectList'];
        })
        .catch(() => this.showErrorMsj(new Error('Se produjo un error al recuperar la información de tipos de documento.')));
    },
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar){
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'apellido' || validarTodos) {
        if (this.$v.apellido.$error) {
          this.apellidoValido = false
          if (!this.$v.apellido.required) {
            this.apellidoInvalidoMsj = 'Debe ingresar el apellido'
          } else if (!this.$v.apellido.maxLength) {
            this.apellidoInvalidoMsj = 'El apellido sólo puede contener hasta 50 caracteres'
          }      
        } else {
          this.apellidoValido = null;
          this.apellidoInvalidoMsj = '';
        }
      }

      if (campo == 'nombre' || validarTodos) {
        if (this.$v.nombre.$error) {
          this.nombreValido = false
          if (!this.$v.nombre.required) {
            this.nombreInvalidoMsj = 'Debe ingresar el nombre'
          } else if (!this.$v.nombre.maxLength) {
            this.nombreInvalidoMsj = 'El nombre sólo puede contener hasta 50 caracteres'
          }      
        } else {
          this.nombreValido = null;
          this.nombreInvalidoMsj = '';
        }
      }

      if (campo == 'documentoNumero' || validarTodos) {
        if (this.$v.documentoNumero.$error) {
          this.documentoNumeroValido = false
          if (!this.$v.documentoNumero.required) {
            this.documentoNumeroInvalidoMsj = 'Debe ingresar el número de documento';
          } else if (!this.$v.documentoNumero.numeric) {
            this.documentoNumeroInvalidoMsj = 'El número de documento sólo puede contener números';
          }
        } else {
          this.documentoNumeroValido = null;
          this.documentoNumeroInvalidoMsj = '';
        }
      }
    },
    save () {
      let save = true;

      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      var documentoTipo = null;
      if (this.documentoTipoNombre) {
        documentoTipo = this.getSelected(this.documentosTipos, this.documentoTipoNombre);
      }
      this.$store.dispatch('personalHijo/setDocumentoTipo', documentoTipo);

      let errorDocumentoTipo = true;
      if (this.documentoTipo) {
        if (this.documentoTipo.id) {
          if (this.documentoTipo.id != 0) {
            errorDocumentoTipo = false;
          }
        }
      }
      if (errorDocumentoTipo) {
        this.documentoTipoValido = false;
        this.documentoTipoInvalidoMsj = 'Debe seleccionar el tipo de documento';
        save = false; 
      }

      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        if (save) {
          this.showSpinner();
          this.$store.dispatch('personalHijo/save')
            .then( () => this.updated())
            .catch( error => this.showErrorMsj (error))
            .finally(() => this.hideSpinner());

          // this.$store.dispatch('personalHijo/save')
          //   .then( () => this.showModalMsj ('Los cambios se registraron con éxito.', 
          //     this.updated, this.updated, 'light'))
          //   .catch( error => this.showErrorMsj (error))
          //   .finally(() => this.hideSpinner());
        }
      }
    },
    updated() {
      this.$emit('hijoActualizado', this.$store.getters['personalHijo/personalHijo']);
    },
    close() {
      this.$emit('closeHijo');
    },
    documentoTipoActualizado(documentoTipoNombre) {
      this.documentoTipoNombre = documentoTipoNombre;
      this.documentoTipoValido = null;
      this.documentoTipoInvalidoMsj = '';
    },
  },
  watch: {
    'fechaNacimientoHijoHabilitada' : function(newVal, oldVal) {
      this.fechaNacimientoHijoDisabled = !(/true/i).test(this.fechaNacimientoHijoHabilitada);
    },
  },
  /* Vuelidate */
  validations: {
    apellido: {
      required,
      maxLength: maxLength(50)
    },
    nombre: {
      required,
      maxLength: maxLength(50)
    },
    fechaNacimiento: {},
    documentoNumero: {
      required,
      numeric
    },
  },  
}
</script>

<style>
</style>
